import { inject } from '@angular/core';
import { HttpEvent, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';
import { SnackbarApi } from '@shared/services/snackbar.api';
import { HttpUtils } from '@shared/modules/api/utils/http.utils';
import { ENVIRONMENT } from '@shared/constants/platform/environment.token';
import { Environment } from '@shared/models/platform/environment.models';
import { AuthStore } from '@shared/modules/auth/store/auth.store';

const SUCCESS_MESSAGE_METHODS: string[] = ['PATCH', 'POST', 'DELETE'];

export const apiUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const snackbarApi = inject(SnackbarApi);
  const environment = inject<Environment>(ENVIRONMENT);
  const accessToken = inject(AuthStore).accessToken();

  const headers = request.headers
    .delete(HttpUtils.skipSuccessMessageHeader)
    .append('Authorization', `Bearer ${accessToken}`);

  return next(request.clone({ url: `${environment.apiUrl}/${request.url}`, headers })).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (isSuccessMessageNeeded(request, event)) snackbarApi.success();
    })
  );
};

function isSuccessMessageNeeded(request: HttpRequest<unknown>, event: HttpEvent<unknown>): boolean {
  if (!(event instanceof HttpResponse) || !event.ok) return false;
  if (request.headers.has(HttpUtils.skipSuccessMessageHeader)) return false;
  return SUCCESS_MESSAGE_METHODS.includes(request.method);
}
